/* eslint-disable no-nested-ternary */
/* eslint-disable object-curly-newline */
import store from 'store';
import { AxiosResponse, AxiosError } from 'axios';
import { getQueryListId } from 'utils';
import { getAudienceListDetailsContactsService } from 'modules/Services/AudienceService';
import {
  LIST_CONTACTS,
  LIST_CONTACTS_SEARCH,
  LIST_CONTACTS_DELETE_CONTACTS,
  LIST_CONTACTS_EDIT_LISTNAME,
  GLOBAL_CONTACTS_DELETE_CONTACTS,
  LIST_CONTACTS_ADD_TO_LIST,
} from 'constants/types/audienceTypesNew';
import { setListDetailsNameError } from 'modules/Campaigns/Audience/Lists/actions';
// prettier-ignore
import { exportAudienceContactsNewService, deleteListContactsServiceNew, deleteGlobalPeopleServiceNew, editListNameService } from 'modules/Services/AudienceServiceNew';
import { ICustomObjectType } from 'constants/interfaces/GlobalInterfaces';
import { AUDIENCE_LISTS } from 'constants/types';
import { IListContactsResponse, IListContactParams, IAudienceAPIError, IResponseObject, IContactItem } from '../interface';
import { IDeleteGlobalContactsParams } from '../interfaces2';
import { ActionTypes } from '../constants';

const { dispatch } = store;

export const onOpenListLoadingUpdate = (value: boolean) => {
  store.dispatch({
    // eslint-disable-next-line
    type: LIST_CONTACTS.OPEN_LIST_LOADING,
    payload: { loading: value },
  });
};

export const getAudienceListContactsAction = (Params: IListContactParams) => {
  const listId = getQueryListId();
  if (!listId) return;
  const { isSort, ...params } = Params;
  if (isSort) {
    dispatch({
      // eslint-disable-next-line
      type: params?.search_term ? LIST_CONTACTS_SEARCH.SORT_LIST : LIST_CONTACTS.SORT_LIST,
    });
  } else {
    dispatch({
      type: params?.search_term ? LIST_CONTACTS_SEARCH.LOAD : LIST_CONTACTS.LOAD,
    });
  }

  getAudienceListDetailsContactsService(String(listId), params)
    .then((res: AxiosResponse<IListContactsResponse>) => {
      // eslint-disable-next-line
      const { data, success, message } = res.data;
      if (success) {
        if (params.search_term && params.search_term !== '') {
          dispatch({
            type: LIST_CONTACTS_SEARCH.SUCCESS,
            payload: {
              listContacts: data[0]?.contacts,
              listId,
              success,
              message,
              // Total count and list name from backend will be correct only when offset is 0.
              ...(params.offset === 0 && { totalContacts: data[0]?.totalContacts, listName: data[0].listName }),
            },
          });
        } else {
          onOpenListLoadingUpdate(false);
          dispatch({
            type: LIST_CONTACTS.SUCCESS,
            payload: {
              listContacts: data[0]?.contacts,
              listId,
              success,
              message,
              // Total count and list name from backend will be correct only when offset is 0.
              ...(params.offset === 0 && { totalContacts: data[0]?.totalContacts, listName: data[0].listName }),
            },
          });
        }

        // store.dispatch({
        //   type: PEOPLE_AUDIENCE.SET_CURRENT_ACTIVE_LIST,
        //   payload: ''
        // })
      } else {
        dispatch({
          type: LIST_CONTACTS.ERROR,
          payload: {
            message,
            success: false,
          },
        });
      }
    })
    .catch((err: AxiosError<IAudienceAPIError>) => {
      console.log('Error getAudienceListDetailsContactsService:', err);
      if (err.message !== 'Operation canceled due to new request.') {
        dispatch({ type: LIST_CONTACTS.FAIL, payload: { message: err.message } });
      }
    });
};

export const setListIdAction = (listId: number) => {
  store.dispatch({
    // eslint-disable-next-line
    type: LIST_CONTACTS.SET_LIST_ID,
    payload: {
      listId,
    },
  });
};

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const resetListContactsDataAction = () => {
  dispatch({ type: LIST_CONTACTS.DATA_RESET });
};

// Dispatch this action to prevent list name load on sorting
export const resetListContactsSorting = () => {
  dispatch({ type: LIST_CONTACTS.RESET_SORT });
};

export const exportAudienceContactsAction = (listId?: string, searchByName?: string, emailId?: string, uuid?: string, noFilters?: boolean) => {
  const {
    contactsFilters: { globalContactsFilters, listContactsFilters },
  } = store.getState();
  const selectedContactsFilters = globalContactsFilters.selectedFilters;
  const selectedListContactsFilters = listContactsFilters.selectedFilters;
  const params: ICustomObjectType = {
    export: 'true',
    filter_by_organization: noFilters ? [] : listId ? selectedListContactsFilters.organization : selectedContactsFilters.organization,
    filter_by_designation: noFilters ? [] : listId ? selectedListContactsFilters.designation : selectedContactsFilters.designation,
    filter_by_personality_type: noFilters
      ? []
      : listId
      ? selectedListContactsFilters.personalityType.join(',')
      : selectedContactsFilters.personalityType.join(','),
    filter_by_status: noFilters ? [] : listId ? selectedListContactsFilters.status.join(',') : selectedContactsFilters.status.join(','),
    ...(searchByName && { search_by_name: searchByName }),
    ...(emailId && { email_id: emailId }),
    ...(uuid && { uuid }),
  };
  store.dispatch({
    type: AUDIENCE_LISTS.ENABLE_EXPORT_LOADER,
  });
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  exportAudienceContactsNewService(params, listId)
    .then((res: AxiosResponse) => {
      if (res) {
        store.dispatch({
          type: AUDIENCE_LISTS.SET_OPEN,
        });
        store.dispatch({
          type: AUDIENCE_LISTS.DISABLE_EXPORT_LOADER,
        });
      }
    })
    .catch((err: AxiosError) => {
      console.log('exportAudienceContactsNewService', err);
    });
};

const totalToRemove = (params: IDeleteGlobalContactsParams) => {
  const totalListCount = store.getState().audienceListDetailsReducerV2.totalContacts;
  const { deleteAll: selectAll, contactIds, excludedContactIds } = params;
  let totalCount = 0;
  if (selectAll && excludedContactIds.length === 0) {
    totalCount = totalListCount;
  } else if (selectAll && excludedContactIds.length > 0) {
    totalCount = totalListCount - excludedContactIds.length;
  } else {
    totalCount = contactIds.length;
  }
  return totalCount;
};

export const removeListContactAction = (params: IDeleteGlobalContactsParams) => {
  dispatch({
    type: LIST_CONTACTS_DELETE_CONTACTS.LOAD,
  });

  return new Promise((resolve, reject) => {
    deleteListContactsServiceNew(params)
      .then((res: AxiosResponse<IResponseObject>) => {
        const { success, message } = res.data;
        const { deleteAll, contactIds, excludedContactIds, listId } = params;
        if (success) {
          dispatch({
            type: AUDIENCE_LISTS.TOTAL_CONTACTS_UPDATE,
            payload: { totalContacts: totalToRemove(params), listId, type: ActionTypes.REMOVE },
          });
          dispatch({
            type: LIST_CONTACTS_DELETE_CONTACTS.SUCCESS,
            payload: { message, deleteAll, contactIds, excludedContactIds },
          });
          resolve({ success, message });
        } else {
          dispatch({
            type: LIST_CONTACTS_DELETE_CONTACTS.FAIL,
            payload: { message },
          });
          // eslint-disable-next-line
          reject({ success: false });
        }
      })
      .catch((err: AxiosError<IResponseObject>) => {
        dispatch({
          type: LIST_CONTACTS_DELETE_CONTACTS.FAIL,
          payload: { message: err.message },
        });
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const deleteListContactsAction = (params: IDeleteGlobalContactsParams) => {
  dispatch({
    type: LIST_CONTACTS_DELETE_CONTACTS.LOAD,
  });
  dispatch({
    type: GLOBAL_CONTACTS_DELETE_CONTACTS.LOAD,
  });
  return new Promise((resolve, reject) => {
    deleteGlobalPeopleServiceNew(params)
      .then((res: AxiosResponse<IResponseObject>) => {
        const { success, message } = res.data;
        const { listId, deleteAll, contactIds, excludedContactIds } = params;
        if (success) {
          dispatch({
            type: AUDIENCE_LISTS.TOTAL_CONTACTS_UPDATE,
            payload: { totalContacts: totalToRemove(params), listId, type: ActionTypes.DELETE },
          });
          dispatch({
            type: LIST_CONTACTS_DELETE_CONTACTS.SUCCESS,
            payload: { message, deleteAll, contactIds, excludedContactIds },
          });
          dispatch({
            type: GLOBAL_CONTACTS_DELETE_CONTACTS.SUCCESS,
            payload: { message, deleteAll, contactIds, excludedContactIds },
          });
        } else {
          dispatch({
            type: LIST_CONTACTS_DELETE_CONTACTS.FAIL,
            payload: { message },
          });
          dispatch({
            type: GLOBAL_CONTACTS_DELETE_CONTACTS.FAIL,
            payload: { message },
          });
        }
        resolve({ success, message });
      })
      .catch((err: AxiosError<IResponseObject>) => {
        dispatch({
          type: LIST_CONTACTS_DELETE_CONTACTS.FAIL,
          payload: { message: err.message },
        });
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const editListNameAction = (listId: string, newListName: string) => {
  store.dispatch({
    type: LIST_CONTACTS_EDIT_LISTNAME.LOAD,
  });
  editListNameService(listId, newListName)
    .then((res: AxiosResponse<IResponseObject>) => {
      const { success, message } = res.data;
      if (success) {
        store.dispatch({
          type: LIST_CONTACTS_EDIT_LISTNAME.SUCCESS,
          payload: { success, message, newListName },
        });
        store.dispatch({
          type: AUDIENCE_LISTS.LIST_NAME_UPDATE,
          payload: { listId, listName: newListName },
        });
      } else if (!success) {
        if (res?.data.message !== '') {
          if (String(res?.data.message).startsWith('List with name')) {
            // List already exist error message
            setListDetailsNameError('List already exists with that name.');
          } else {
            setListDetailsNameError(res?.data.message);
          }
        }
        store.dispatch({
          type: LIST_CONTACTS_EDIT_LISTNAME.FAIL,
          payload: { message },
        });
      }
    })
    .catch((err: AxiosError<IResponseObject>) => {
      store.dispatch({
        type: LIST_CONTACTS_EDIT_LISTNAME.FAIL,
        payload: { message: err.message },
      });
    });
};

export const setListDetailSearchTermAction = (searchTerm: string) => {
  dispatch({
    type: LIST_CONTACTS_SEARCH.SET_SEARCH_TERM,
    payload: { searchTerm },
  });
};

export const resetSearchedListContactsAction = () => {
  dispatch({
    type: LIST_CONTACTS_SEARCH.RESET,
  });
};
export const resetPreviousNameListContactsAction = () => {
  dispatch({
    type: LIST_CONTACTS.PREV_NAME_RESET,
  });
};

export const closeExportAudienceContactsPopupAction = () => {
  dispatch({ type: AUDIENCE_LISTS.SET_CLOSE });
};

export const reloadListDetailsContactsAction = (reloadFlag: boolean) => {
  dispatch({
    type: LIST_CONTACTS.RELOAD,
    payload: { reloadFlag },
  });
};

export const removeSearchTermOnly = () => {
  dispatch({
    type: LIST_CONTACTS_SEARCH.REMOVE_SEARCH_TERM,
  });
};

export const listTotalContactUpdate = (totalContacts: number) => {
  dispatch({
    type: LIST_CONTACTS_ADD_TO_LIST.UPDATE_TOTAL_COUNT,
    payload: {
      totalContacts,
    },
  });
};

export const addContactsToExistingListAction = (contacts: IContactItem[], updatedCount: number, listId?: number) => {
  // console.info(contacts);
  dispatch({
    type: LIST_CONTACTS_ADD_TO_LIST.ADD,
    payload: { contacts, updatedCount },
  });
  // Update total count in audience list after adding to list
  if (listId) {
    console.log('updatedCount', updatedCount);
    dispatch({
      type: AUDIENCE_LISTS.TOTAL_CONTACTS_UPDATE,
      payload: { totalContacts: updatedCount, listId, type: ActionTypes.ADD_TO_LIST },
    });
  }
};
